import React, { Fragment } from "react";
import { debounce } from "lodash";
import { Modal, Icon, Confirm } from "semantic-ui-react";
import { connect } from "react-redux";
import $ from "jquery";
import { amazonCalculator } from "./buttonHandlers/buttonHandlers";
import { calcAutoMargin } from "./buttonHandlers/analysis";
import FamilyManagement from "./ContextMenu/Menus/FamilyManagementProduct/FamilyManagement";
import {
  openFamiliesProduct,
  openInLink,
  openListing,
} from "./buttonHandlers/openData";
import { appendUnixDate } from "../_genericButtonHandlers/appendUnixDate";
import { appendValue, clearData } from "./buttonHandlers/appendCol";
import { addNotification } from "../../../redux/actions/notificationActions";
import {
  getViewableListingColumns,
  masterListingColumnSet,
  nestedTableColumns,
} from "./ptListingColumns";
import _ from "lodash";
import DataTablesEditor from "../DatatablesEditor/DataTablesEditor";
import BarcodeGenerator from "../../utilities/BarcodeGenerator";
import dvdlocator, { baseURL } from "../../../apis/dvdlocator";
import ModalSwitch from "./buttonHandlers/modals/ModalSwitch";
import MessageModal from "../../MessageModal";
import ShelvingLabelGenerator from "../../utilities/ShelvingLabelGenerator";
import { createQueryParamsFromOptions } from "./filterQueryHelper";
import { renderDate } from "../../formatting/dateFormat";
import ListingContextMenu from "./ContextMenu/ListingContextMenu";
import { masterInventoryColumnSet } from "./ptInventoryColumns";
import { CreateProductWizard } from "../../forms/CreateProductWizard/CreateProductWizard";
import { InventoryCombinationsDisplay } from "./ContextMenu/Menus/ProductInventoryCombinations/InventoryCombinationsDisplay";

class ListingTable extends React.Component {
  constructor(props) {
    super(props);

    this.searchDelay = null;
    this.barCodeType = null;
    this.rowData = [];
    this.datatable = null;

    this.datatableOptions = {
      dom: "Brtip", // https://datatables.net/reference/option/dom
      processing: true,
      serverSide: true,
      select: {
        selector: "td:not(:first-child)",
      },
      paging: true,
      pageLength: 100,
      lengthChange: true,
      autoWidth: true,
      scrollY: this.props.tableHeight,
      scrollX: true,
      scrollCollapse: true,

      colReorder: { realtime: false },
      deferRender: true,
      deferLoading: true,
      order: [[1, "asc"]],

      lengthMenu: [25, 50, 100, 300, 500, 1000],
    };

    this.state = {
      productFormPage: 1,
      productFormMode: "create",
      displayProductWizard: false,
      initialProduct: null,
      preselectedSupplyUnits: [],

      confirmCloseModalOpen: false,
      modalName: "",
      selectedRowsArray: [],
      appendStatus: false,
      appendErrors: [],
      appendColumnNames: [],
      appendTableNames: [],
      isLoading: false,
      modalIsActive: false,
      msg: "",
      slotLabelModalIsActive: false,

      isOpenMessageModal: false,
      contextMenu: {
        display: false,
        event: null,
        rowsPreselected: false,
        modal: "",
        products: [],
        loading: false,
      },

      dtProductColumns: getViewableListingColumns(),
      dtEditorFields: masterListingColumnSet,

      outputLog: [],
      outputLogClearedTimestamp: null,

      render: true,
    };

    this.dataTablesRef = React.createRef();
  }

  resetColumns(dt) {
    const url = window.location.href;
    // Special case- if viewing a collection, must keep the product family search filter
    const keepFamilySearch = url.includes("/family/");

    const searchInputs = document.querySelectorAll(".header_search_input_dt");
    const nullFilters = document.querySelectorAll(".header_checkbox_input_dt");

    searchInputs.forEach((element) => (element.value = ""));
    nullFilters.forEach((element) => (element.checked = false));

    // Setting all null filters to false (Control)
    this.setState({
      dtProductColumns: this.state.dtProductColumns.map((col) => ({
        ...col,
        filterNulls: false,
      })),
    });

    if (!keepFamilySearch) return dt.columns().search("").draw();

    const familySearch = this.props.match.params.family;
    dt.columns()
      .search("")
      .column("product_families_view.families:name")
      .search(familySearch)
      .draw();
  }

  clearOutputLog = () => {
    this.setState((prev) => ({
      outputLogClearedTimestamp: renderDate(Math.floor(Date.now() / 1000)),
      outputLog: prev.outputLog.filter(
        (_, i) => i === prev.outputLog.length - 1
      ),
    }));
  };

  rerenderTableNewColumnSet() {
    const existingSearches = this.existingColumnSearches();

    let viewableColumns = getViewableListingColumns(
      this.props.currentColumnSet.columns.listingColumns
    );

    viewableColumns.forEach((column) => {
      const match = existingSearches.find((search) => {
        return search.data === column.data;
      });

      if (match) {
        column.search = {
          value: match.search,
        };
      }
    });

    // forces datatable to re-render with updated columns
    this.setState(
      {
        dtProductColumns: viewableColumns,
      },
      () => {
        this.setState({ render: !this.state.render }, () => {
          this.datatable.draw();
        });
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentColumnSet.name !== this.props.currentColumnSet.name) {
      this.rerenderTableNewColumnSet();
    }

    if (prevProps.searchValue !== this.props.searchValue) {
      // clearing previous search value (we handle searching with our custom smartSearch)

      this.datatable.search("").draw(true);
    }

    if (!_.isEqual(prevProps.filterOptions, this.props.filterOptions)) {
      // updating ajax and reloading when applying filters

      this.datatable.ajax
        .url(
          `${baseURL}/datatables/pricetool/product${createQueryParamsFromOptions(
            this.props.filterOptions
          )}`
        )
        .load();
    }

    // updating datatable as ref object changes
    this.datatable = this.dataTablesRef.current.dataTable;
    this.props.setParentComponentTableRef(this.dataTablesRef.current.dataTable);
  }

  async componentDidMount() {
    while (this.dataTablesRef === null) {
      await new Promise((resolve) => setTimeout(resolve, 100)); // waiting for datatables
    }

    this.datatable = this.dataTablesRef.current.dataTable;

    if (this.props.searchValue) {
      this.datatable.search(this.props.searchValue); // run initial search if given
    }

    const queryParams = new URLSearchParams(window.location.search);

    // Process product column searches
    const productSearches = {};

    // Collect all listingColumnSearches parameters
    for (const [key, value] of queryParams.entries()) {
      if (key.startsWith("listingColumnSearches[")) {
        // Extract the column name from between the brackets
        const columnName = key.match(/\[(.*?)\]/)[1];
        productSearches[columnName] = value;
      }
    }

    // Apply product column searches
    Object.entries(productSearches).forEach(([columnName, columnSearch]) => {
      const searchInput = document.getElementById(
        `header_search_${columnName}`
      );
      if (searchInput) {
        searchInput.value = columnSearch;
      }

      this.datatable.column(`${columnName}:name`).search(columnSearch);
    });

    // Handles loading column set cases
    if (this.props.currentColumnSet.name) {
      this.rerenderTableNewColumnSet();
    } else if (queryParams.get("colset") === null) {
      this.datatable.draw(); // if colset param is provided, draw will occur from componentDidUpdate
    }

    // Updating parent component ref
    this.props.setParentComponentTableRef(this.datatable);
  }

  rowHasChildren = (row) => {
    return row.inventory && row.inventory.length > 0;
  };

  formatNestedRows = (d) => {
    const columnsToDisplay = nestedTableColumns;

    if (!d.inventory || d.inventory.length === 0) {
      return null;
    }

    // Create table using DOM methods
    const table = document.createElement("table");

    // Add the specific attributes and styling from the original table
    table.setAttribute("cellpadding", "5");
    table.setAttribute("cellspacing", "0");
    table.setAttribute("border", "0");
    table.setAttribute("width", "1500px");
    table.setAttribute("class", "nested-subtable");
    table.style.paddingLeft = "50px";

    // Create header row
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    columnsToDisplay.forEach((col) => {
      const column = masterInventoryColumnSet.find(
        (colDef) => colDef.data === col
      );

      const th = document.createElement("th");
      th.innerHTML = column.title;
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement("tbody");

    // Generate data rows
    d.inventory
      .sort((a, b) => Number(a.supply.sort) - Number(b.supply.sort))
      .forEach((inventory) => {
        const tr = document.createElement("tr");

        columnsToDisplay.forEach((col) => {
          const [table, column] = col.split(".");
          const columnDef = masterInventoryColumnSet.find(
            (colDef) => colDef.data === col
          );

          const td = document.createElement("td");

          if (!columnDef.render) {
            const value = inventory[table][column] || "";
            if (
              typeof value === "string" &&
              ((value.trim().startsWith("<") && value.includes(">")) ||
                value.includes("&lt;") ||
                value.includes("&gt;") ||
                value.includes("&amp;"))
            ) {
              // Likely HTML content, use innerHTML
              td.innerHTML = value;
            } else {
              // Not HTML, use textContent for safety
              td.textContent = value;
            }
          } else {
            // For columns with render function
            const renderedContent = columnDef.render(
              inventory[table][column],
              null,
              inventory
            );

            td.innerHTML = renderedContent;
          }

          tr.appendChild(td);
        });

        tbody.appendChild(tr);
      });

    table.appendChild(tbody);

    return table.outerHTML;
  };

  handleAppendMessage = (rows, status, errorFields) => {
    this.setState({
      modalName: "AppendMessage",
      selectedRowsArray: rows.toArray(),
      appendStatus: status,
      appendErrors: errorFields,
    });
  };

  handleNullFilter = (columnName, isFiltered, dt) => {
    this.setState(
      {
        dtProductColumns: this.state.dtProductColumns.map((col) =>
          col.data === columnName ? { ...col, filterNulls: isFiltered } : col
        ),
      },
      () => {
        dt.draw();
      }
    );
  };

  showAppendForm = (tableNames, columnNames) => {
    this.setState({
      modalName: "AppendForm",
      appendColumnNames: columnNames,
      appendTableNames: tableNames,
    });
  };

  submitAppendForm = (appendDateFlag, formData) => {
    let editor;
    if (!appendDateFlag) {
      editor = appendValue(
        this.datatable,
        this.dataTablesRef.current.editor,
        this.state.appendTableNames,
        this.state.appendColumnNames.map((col) => col.name),
        formData
      );
    } else {
      editor = appendUnixDate(
        this.datatable,
        this.dataTablesRef.current.editor,
        this.state.appendTableNames,
        this.state.appendColumnNames.map((col) => col.name)
      );
    }

    const selectedRowsApi = this.datatable.rows({ selected: true }).data();

    editor &&
      editor.submit(
        () => {
          this.handleAppendMessage(selectedRowsApi, true);
        },
        (errObj) => {
          this.handleAppendMessage(selectedRowsApi, false, errObj.fieldErrors);
        }
      );
  };

  // search field onChange event handler
  onChangeSearch = (e) => {
    const { value } = e.target;
    const searchValue = value;

    this.setState({ searchValue });

    // waits for user to stop typing for 2 seconds to run search
    clearTimeout(this.searchDelay);
    this.searchDelay = setTimeout(() => {
      this.datatable.draw();
    }, 2000);
    this.displayLoading();
  };

  handleSubmit = (e) => {
    // if user has pressed the enter key, trigger search immediately
    if (e.key === "Enter") {
      clearTimeout(this.searchDelay);
      this.displayLoading();
      this.datatable.draw();
    }
  };

  // changes the state of the loading icon on the application after 1 second of inactivity from the user
  displayLoading = debounce(() => {
    this.setState({ isLoading: true });
  }, 1000);

  customButtons = () => {
    return [
      {
        text: "<span title='Refresh Table'>Refresh</span>",
        action: (e, dt, node, config) => {
          dt.ajax.reload();
        },
      },
      {
        text: "<span title='Clears the filters, searches, and sorts of your column only'>Reset Columns</span>",
        action: (e, dt, node, config) => {
          this.resetColumns(dt);
        },
      },
      {
        text: "<select title='Select the input mode for the Amazon Price Calculator. \n\nCogs-Only: Only asks for the Cost of the Good.' style='font-size: 10px;width:35px;height:100%;' id='selectamzcalcfillmode'><option>Cogs-Only</option></select> <select style='font-size: 10px;width:35px;height:100%;' id='selectamzcalc2'><option>None</option><option>Single</option><option>Multi</option></select>",
        action: function (e, dt, node, config) {},
      },
      {
        extend: "selectedSingle",
        text: "<span title='Amazon Price Calculator'>Amz Price Calc</span>",
        action: async (e, dt, node, config) => {
          const fees = await amazonCalculator(dt);

          console.log(fees);

          if (fees) {
            this.props.appendOutputLog(fees);
          }
        },
      },
      {
        extend: "collection",
        text: "<span title='Analyze Item'>Analysis</span>",
        autoClose: true,
        buttons: [
          {
            text: "<span title='Copy selected UPCs'>MSKUs</span>",
            action: (e, dt, node, config) => {
              const data = dt.rows({ selected: true }).data();
              let mskus = [];

              data.each((row) => {
                mskus.push(row["product"]["msku"]);
              });

              if (mskus.length) {
                this.setState({
                  msg: mskus.join(","),
                  isOpenMessageModal: true,
                });
              } else {
                alert("Please select row(s)");
              }
            },
          },
          {
            text: "<span title='Sum up the values of a specific column for selected rows.'>Sum Column</span>",
            action: (e, dt, node, config) => {
              const selectedRowsApi = dt.rows({ selected: true }).data();
              this.setState({
                modalName: "SumColumn",
                selectedRowsArray: selectedRowsApi.toArray(),
              });
            },
          },
          {
            text: "<span title='Push the current Next Ship Qty value into the Amz Ship Qty column.'>NSQ to ASQ</span>",
            action: (e, dt, node, config) => {
              const rows = dt.rows({ selected: true });

              const editor = this.dataTablesRef.current.editor;
              editor.edit(rows.indexes(), false);

              rows.every(function () {
                const data = this.data();
                const nextShipQty = data.product.next_amz_ship_qty;
                editor
                  .field("product.amz_ship_qty")
                  .multiSet(data.DT_RowId, nextShipQty);
                return null;
              });

              editor.submit(
                () => {
                  this.props.addNotification({
                    text: `Successfully pushed Next Ship Qty to Amz Ship Qty!`,
                    icon: <Icon color="green" name="checkmark box" />,
                  });
                },
                (errObj) => {
                  console.log(errObj);
                  this.props.addNotification({
                    text: `Error pushing Next Ship Qty to Amz Ship Qty.`,
                    icon: <Icon color="red" name="warning circle" />,
                  });
                }
              );
            },
          },
          {
            text: "<span title='Push the current Yom Ship Rec value into the Next Ship Qty column.'>YSR to NSQ</span>",
            action: (e, dt, node, config) => {
              const rows = dt.rows({ selected: true });

              const editor = this.dataTablesRef.current.editor;
              editor.edit(rows.indexes(), false);

              rows.every(function () {
                const data = this.data();
                const yomShipRec = data.product.yom_ship_rec;
                editor
                  .field("product.next_amz_ship_qty")
                  .multiSet(data.DT_RowId, yomShipRec);
                return null;
              });

              editor.submit(
                () => {
                  this.props.addNotification({
                    text: `Successfully pushed Yom Ship Rec to Next Ship Qty!`,
                    icon: <Icon color="green" name="checkmark box" />,
                  });
                },
                (errObj) => {
                  console.log(errObj);
                  this.props.addNotification({
                    text: `Error pushing Yom Ship Rec to Next Ship Qty.`,
                    icon: <Icon color="red" name="warning circle" />,
                  });
                }
              );
            },
          },
          {
            text: "Auto Margin Script",
            action: (e, dt, node, config) => {
              calcAutoMargin();
            },
          },
          {
            text: "Amazon Orders Script",
            action: (e, dt, node, config) => {
              alert("Not implemented yet");
            },
          },
          {
            text: "ATS Script",
            action: (e, dt, node, config) => {
              dvdlocator
                .post("/invoke-ats")
                .then((res) => {
                  if (res.data.includes("Task already running")) {
                    this.props.addNotification({
                      text: `ATS task already running.`,
                      icon: <Icon color="yellow" name="checkmark box" />,
                    });
                  } else
                    this.props.addNotification({
                      text: `Successfully started ATS task!`,
                      icon: <Icon color="green" name="checkmark box" />,
                    });
                })
                .catch((err) =>
                  this.props.addNotification({
                    text: `Error starting ATS script.`,
                    icon: <Icon color="red" name="warning circle" />,
                  })
                );
            },
          },
          {
            text: "MAVCG Script",
            action: (e, dt, node, config) => {
              dvdlocator
                .post("/invoke-mavcg")
                .then((res) => {
                  if (res.data.includes("Task already running")) {
                    this.props.addNotification({
                      text: `MAVCG task already running.`,
                      icon: <Icon color="green" name="checkmark box" />,
                    });
                  } else
                    this.props.addNotification({
                      text: `Successfully started MAVCG task!`,
                      icon: <Icon color="green" name="checkmark box" />,
                    });
                })
                .catch((err) =>
                  this.props.addNotification({
                    text: `Error starting MAVCG script.`,
                    icon: <Icon color="red" name="warning circle" />,
                  })
                );
            },
          },
          {
            extend: "selected",
            text: "Retire/Unretire",
            action: (e, dt, node, config) => {
              const products = dt.rows({ selected: true });

              const productIds = products
                .data()
                .map((item) => item.product.product_id)
                .toArray();

              let retiring = true;

              products.every(function (i, tableLoop, rowLoop) {
                const data = this.data();
                if (data.product.retired) retiring = false;
                return null;
              });

              dvdlocator
                .post("/products/retire", { productIds, retired: retiring })
                .then(() => {
                  this.props.addNotification({
                    text: `Successfully ${
                      retiring ? "retired" : "unretired"
                    } product(s)!`,
                    icon: <Icon color="green" name="checkmark box" />,
                  });
                  dt.ajax.reload();
                })
                .catch((err) => {
                  console.log(err);
                  this.props.addNotification({
                    text: `There was an error ${
                      retiring ? "retiring" : "unretiring"
                    } the product(s)!`,
                    icon: <Icon color="red" name="warning circle" />,
                  });
                });
            },
          },
          {
            text: "Refresh Analytics Columns",
            action: (e, dt, node, config) => {
              dvdlocator
                .post("/refresh-analytics-db-columns")
                .then((res) => {
                  this.props.addNotification({
                    text: `Successfully started task! Please wait a moment for update.`,
                    icon: <Icon color="green" name="checkmark box" />,
                  });
                })
                .catch((err) =>
                  this.props.addNotification({
                    text: `Error starting task.`,
                    icon: <Icon color="red" name="warning circle" />,
                  })
                );
            },
          },
        ],
        fade: 100,
      },
      {
        extend: "collection",
        text: "<span title='Ware House Actions'>Warehouse</span>",
        autoClose: true,
        buttons: [
          {
            extend: "selected",
            text: "<span title='Amazon Barcode'>Amazon Barcode</span>",
            action: (e, dt, node, config) => {
              const data = dt.rows({ selected: true }).data();

              // reset rowData first
              this.rowData = [];

              if (data.length === 1) {
                const count = prompt(
                  "How many copies of this barcode would you like?",
                  1
                );

                // add count copies of data[0] to this.rowData
                for (let i = 0; i < count; i++) {
                  this.rowData.push(data[0]);
                }
              } else {
                // otherwise add amz_ship_qty amount of each row
                for (let i = 0; i < data.length; i++) {
                  const { amz_ship_qty } = data[i].product;

                  if (amz_ship_qty > 0) {
                    for (let j = 0; j < amz_ship_qty; j++) {
                      this.rowData.push(data[i]);
                    }
                    // if amz_ship_qty empty or 0, just add one copy
                  } else {
                    this.rowData.push(data[i]);
                  }
                }
              }

              this.barCodeType = "amazon";
              this.setState({ modalIsActive: true });
            },
          },
          {
            extend: "selected",
            text: "<span title='Generate warehouse shelving slot label for selected row(s)'>Generate Slot Label</span>",
            action: (e, dt, node, config) => {
              const data = dt.rows({ selected: true }).data();
              // reset rowData first
              this.rowData = [];

              if (data.length === 1) {
                const count = prompt(
                  "How many copies of this label would you like?",
                  1
                );
                // add count copies of data[0] to this.rowData
                for (let i = 0; i < count; i++) {
                  this.rowData.push(data[0]);
                }
              } else {
                this.rowData = data;
              }
              this.setState({ slotLabelModalIsActive: true });
            },
          },
        ],
        fade: 100,
      },
      {
        extend: "collection",
        text: "<span title='Jons Precious Menu'>Curator</span>",
        autoClose: true,
        buttons: [
          {
            text: "<span title='Append / Remove from Listory'>Append Listory</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "listory", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Clear Sort Column '>Clear \"Sort\" Column</span>",
            action: (e, dt, node, config) => {
              if (
                window.confirm(
                  "Are you sure you would like to clear the data in the Sort column?"
                )
              ) {
                clearData(
                  dt,
                  this.dataTablesRef.current.editor,
                  ["product"],
                  ["sort"]
                );
              }
            },
          },
        ],
      },
      {
        extend: "collection",
        text: "<span title='Search for Items'>Open</span>",
        autoClose: true,
        buttons: [
          {
            text: "<span title='Open Families'>Product Families</span>",
            action: (e, dt, node, config) => {
              openFamiliesProduct(dt, this.props.currentColumnSet.name);
            },
          },
          {
            text: "<span title='Open Listing and Inventory rows in Pricetool'>Open Listing</span>",
            action: (e, dt, node, config) => {
              openListing(dt, this.props.currentColumnSet.name);
            },
          },
          {
            text: "<span title='Open ItemIDs in Repricer Express'>Repricer</span>",
            action: (e, dt, node, config) => {
              openInLink(
                dt,
                "https://dashboard-5.repricer.com/repricer?fai_fca_id%5B%5D=52849&fsf_query=",
                "product",
                "msku",
                ""
              );
            },
          },
          {
            text: "<span title='Open UPC in Amazon Order History' >Order History</span>",
            action: (e, dt, node, config) => {
              openInLink(
                dt,
                "https://sellercentral.amazon.com/orders-v3/search?page=1&date-range=last-7&q=",
                "product",
                "msku",
                "&qt=sku"
              );
            },
          },
          {
            text: "<span title='Open UPC in Amazon Orders table' >Orders</span>",
            action: (e, dt, node, config) => {
              openInLink(
                dt,
                "/datatables/amazon-orders/",
                "product",
                "msku",
                ""
              );
            },
          },
          {
            text: "<span title='Open ASIN in Buy Box' >Buy Box</span>",
            action: (e, dt, node, config) => {
              openInLink(
                dt,
                "https://www.amazon.com/dp/",
                "product",
                "product_asin",
                ""
              );
            },
          },
          {
            text: "<span title='Open UPC in Re-Stock / Price' >Re-Stock</span>",
            action: (e, dt, node, config) => {
              openInLink(
                dt,
                "https://sellercentral.amazon.com/inventory/view/PRICING?tbla_myitable=sort:%7B%22sortOrder%22%3A%22DESCENDING%22%7D;search:",
                "product",
                "fnsku",
                ";pagination:1;"
              );
            },
          },
          {
            text: "<span title='Open inventory management for ASIN in Seller Central' >Manage Inventory</span>",
            action: (e, dt, node, config) => {
              dt.rows({ selected: true }).every(function () {
                const rowData = this.data();
                const asin = rowData.product.product_asin;

                if (asin && asin.trim()) {
                  const trimmedAsin = asin.trim();
                  window.open(
                    `https://sellercentral.amazon.com/myinventory/inventory?fulfilledBy=all&page=1&pageSize=10&searchField=all&searchTerm=${trimmedAsin}&sort=sales_desc&status=all`
                  );
                }

                return null;
              });
            },
          },
        ],
        fade: 100,
      },
      {
        extend: "collection",
        text: "<span title='Append to Table'>Append</span>",
        buttons: [
          {
            text: "<span title='Append / Remove from Part_Number'>Partnum</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "part_number", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Amazon_Queue'>Amazon Queue</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "amz_queue", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Orders'>Orders</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "orders", type: "string" }]
              );
            },
          },

          {
            text: "<span title='Append / Remove from Warehouse Notes'>Wn</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "wn", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Warehouse Work Orders'>WWO</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "wwo", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Analyst Notes'>AN</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "an", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Pick Status'>Pick Status</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "pick_status", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append/remove from Amazon Queue and Next Ship Qty'>Amazon Queue & Next Ship Qty</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product", "product"],
                [
                  { name: "amz_queue", type: "string" },
                  { name: "next_amz_ship_qty", type: "number" },
                ]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Pricing Notes'>Pricing Notes</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "pricing_notes", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Threading Notes'>Threading Notes</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "threading_notes", type: "string" }]
              );
            },
          },
          {
            text: "<span title='Append / Remove from Curation Notes'>Curation Notes</span>",
            action: (e, dt, node, config) => {
              this.showAppendForm(
                ["product"],
                [{ name: "curation_notes", type: "string" }]
              );
            },
          },
        ],
        fade: 100,
      },
    ];
  };

  existingColumnSearches() {
    const columns = this.datatable.columns();

    const searches = [];

    columns.every(function () {
      const data = this.dataSrc();
      const search = this.search();

      if (search !== "") {
        searches.push({
          data,
          search,
        });
      }
      return null;
    });

    return searches;
  }

  closeFormModal = () => {
    this.setState({
      modalName: "",
      selectedRowsArray: [],
    });
  };

  shapeProductDataForWizard = (row) => {
    return {
      product_id: row.product.product_id,
      title: row.product.product_title,
      partNumber: row.product.assembly_part_number,
      asin: row.product.product_asin,
      families: row.product_families.map((subRow) => ({
        id: subRow.id,
        title: subRow.family,
      })),
    };
  };

  shapeSupplyUnitDataForWizard = (rows) => {
    return rows.map((row) => ({
      upc: row.supply.upc,
      supply_title: row.supply.supply_title,
      part_number: row.inventory.part_number,
      inventory_id: row.supply.inventory_id,
      inventory_title: row.inventory.inventory_title,
    }));
  };

  // handler for opening the barcode modal
  setModalOpen = (val) => {
    this.setState({
      modalIsActive: val,
      barcodeModalIsActive: val,
      slotLabelModalIsActive: val,
      isOpenMessageModal: val,
    });
  };

  openDuplicateForm = () => {
    const dt = this.dataTablesRef.current.dataTable;
    const row = dt.row({ selected: true }).data();

    const productData = this.shapeProductDataForWizard(row);
    this.setState({
      initialProduct: productData,
      displayProductWizard: true,
      productFormMode: "duplicate",
    });
  };

  handleContextMenu = (e) => {
    if (window.getSelection().toString()) return; // if the user has highlighted text

    e.preventDefault();
    let rowsPreselected = true;

    $("tr").removeClass("contextmenu"); // cleaning other selections

    const dt = this.dataTablesRef.current.dataTable;
    let rows = dt.rows({ selected: true }).data().toArray();

    const clickedRow = $(e.target).closest("tr").first();

    // If no selection, use the right-clicked row
    if (rows.length === 0) {
      rowsPreselected = false;

      const deselectRow = () => {
        clickedRow.removeClass("contextmenu");
      };

      clickedRow.addClass("contextmenu");
      window.addEventListener("click", deselectRow, { once: true });

      rows = dt
        .rows([`#${clickedRow.attr("id")}`])
        .data()
        .toArray();
    }

    this.setState((prev) => ({
      ...prev,
      selectedRowsArray: rows,
      contextMenu: {
        ...prev.contextMenu,
        display: true,
        event: e,
        rowsPreselected: rowsPreselected,
      },
    }));
  };

  toggleTableVisibility = (tableName) => {
    this.setState((prevState) => ({
      [`${tableName}TableOpen`]: !prevState[`${tableName}TableOpen`],
    }));
  };

  closeCreateForm = (skipConfirmation) => {
    if (skipConfirmation) {
      this.setState({
        displayProductWizard: false,
        initialProduct: null,
        preselectedSupplyUnits: [],
        productFormMode: "create",
        productFormPage: 1,
      });
    } else {
      this.setState({
        confirmCloseModalOpen: true,
        preselectedSupplyUnits: [],
        productFormMode: "create",
        productFormPage: 1,
      });
    }
  };

  handleConfirmClose = () => {
    this.setState({
      initialProduct: null,
      displayProductWizard: false,
      confirmCloseModalOpen: false,
    });
  };

  handleConfirmCloseCancel = () => {
    this.setState({ confirmCloseModalOpen: false });
  };

  render() {
    const {
      dtEditorFields,
      dtProductColumns,
      modalIsActive,
      displayProductWizard,
      confirmCloseModalOpen,
      slotLabelModalIsActive,
    } = this.state;

    return (
      <Fragment>
        <Confirm
          open={confirmCloseModalOpen}
          content="Are you sure you want to close the create form? Any unsaved changes will be lost."
          onCancel={this.handleConfirmCloseCancel}
          onConfirm={this.handleConfirmClose}
        />
        {displayProductWizard && (
          <CreateProductWizard
            onClose={this.closeCreateForm}
            preselectedSupplyUnits={this.state.preselectedSupplyUnits}
            initialProduct={this.state.initialProduct}
            initialPage={this.state.productFormPage}
            mode={this.state.productFormMode}
          />
        )}
        <ListingContextMenu
          open={this.state.contextMenu.display}
          event={this.state.contextMenu.event}
          selectedRows={this.state.selectedRowsArray}
          rowsPreselected={this.state.contextMenu.rowsPreselected}
          openEditPartNumber={() => {
            const row = this.state.selectedRowsArray[0];
            const productData = this.shapeProductDataForWizard(row);
            this.setState({
              displayProductWizard: true,
              productFormMode: "edit",
              initialProduct: productData,
            });
          }}
          openEditInventory={() => {
            const row = this.state.selectedRowsArray[0];
            const productData = this.shapeProductDataForWizard(row);
            this.setState({
              initialProduct: productData,
              displayProductWizard: true,
              productFormMode: "edit",
              productFormPage: 2,
            });
          }}
          openContextModal={(modalName) =>
            this.setState((prev) => ({
              ...prev,
              contextMenu: { ...prev.contextMenu, modal: modalName },
            }))
          }
          closeContextMenu={() =>
            this.setState((prev) => ({
              contextMenu: {
                ...prev.contextMenu,
                display: false,
                event: null,
              },
            }))
          }
        />
        {this.state.contextMenu.modal === "family" && (
          <FamilyManagement
            open={this.state.contextMenu.modal === "family"}
            close={() => {
              this.dataTablesRef.current.dataTable.ajax.reload();
              this.setState((prev) => ({
                ...prev,
                contextMenu: { ...prev.contextMenu, modal: "" },
              }));
            }}
            loading={this.state.contextMenu.loading}
            initialProducts={this.state.selectedRowsArray}
          />
        )}
        {this.state.contextMenu.modal === "inventory-combinations" && (
          <InventoryCombinationsDisplay
            open={this.state.contextMenu.modal === "inventory-combinations"}
            close={() => {
              this.setState((prev) => ({
                ...prev,
                contextMenu: { ...prev.contextMenu, modal: "" },
              }));
            }}
            product={this.state.selectedRowsArray[0]}
          />
        )}

        <MessageModal
          open={this.state.isOpenMessageModal}
          msg={this.state.msg}
          setOpen={this.setModalOpen}
          copy={true}
        />
        <ModalSwitch
          closeModal={this.closeFormModal}
          selectedRows={this.state.selectedRowsArray}
          modalName={this.state.modalName}
          appendStatus={this.state.appendStatus}
          appendErrors={this.state.appendErrors}
          columnNames={this.state.appendColumnNames}
          submitAppendForm={this.submitAppendForm}
          mode={"product"}
        />

        <Modal
          closeOnDimmerClick
          open={modalIsActive}
          onClose={() => this.setModalOpen(false)}
          style={{ textAlign: "center" }}
        >
          <Modal.Content image>
            <Modal.Description>
              <BarcodeGenerator
                height={50}
                fontSize={22}
                textMargin={1}
                margin={0}
                barCodeType={this.barCodeType}
                rowData={this.rowData}
              />
            </Modal.Description>
          </Modal.Content>
        </Modal>
        <Modal
          closeOnDimmerClick
          open={slotLabelModalIsActive}
          onClose={() => this.setModalOpen(false)}
          style={{ textAlign: "center" }}
        >
          <Modal.Content image>
            <Modal.Description>
              {
                <ShelvingLabelGenerator
                  rowData={this.rowData}
                  type={"product"}
                />
              }
            </Modal.Description>
          </Modal.Content>
        </Modal>

        <DataTablesEditor
          key={this.state.render}
          ref={this.dataTablesRef}
          ajax={{
            url: `${baseURL}/datatables/pricetool/product${createQueryParamsFromOptions(
              this.props.filterOptions
            )}`,
            contentType: "application/json",
            type: "POST",
            data: (d) => {
              this.state.dtProductColumns.forEach((col) => {
                const i = d.columns.findIndex(
                  (column) => column.data === col.data
                );
                if (col.filterNulls) d.columns[i].filterNulls = true;
                if (col.excludeFromGeneralSearch === true)
                  d.columns[i].excludeFromGeneralSearch = true;
              });

              d.columns = d.columns.filter((col) => col.data !== null);
              d.smartSearch = this.props.searchValue;
              return JSON.stringify(d);
            },
          }}
          editorAjax={{
            url: `${baseURL}/datatables/pricetool/product`,
            contentType: "application/json",
            type: "POST",
            data: function (d) {
              return JSON.stringify(d);
            },
          }}
          inlineEditSubmitAll={true}
          rowHasChildren={this.rowHasChildren}
          rowExpansion={this.formatNestedRows}
          handleContextMenu={this.handleContextMenu}
          columns={dtProductColumns}
          options={this.datatableOptions}
          fields={dtEditorFields}
          pageLengthButton={true}
          createButton={true}
          customCreateButtonInit={(editor) => ({
            extend: "collection",
            text: "New",
            buttons: [
              {
                editor,
                text: "<span title='Create a brand new product'>Create New</span>",
                action: () => {
                  if (this.props.inventoryTableRef?.current) {
                    const rows = this.props.inventoryTableRef.current
                      .rows({ selected: true })
                      .data()
                      .toArray();

                    const formattedSupplyUnits =
                      this.shapeSupplyUnitDataForWizard(rows);

                    this.setState({
                      displayProductWizard: true,
                      preselectedSupplyUnits: formattedSupplyUnits,
                    });
                  } else {
                    this.setState({ displayProductWizard: true });
                  }
                },
              },
              {
                extend: "selectedSingle",
                editor,
                text: "<span title='Create a duplicate of the selected product'>Duplicate Existing</span>",
                action: () => this.openDuplicateForm(),
              },
            ],
          })}
          onDraw={() => this.setState({ isLoading: false })}
          // customEdit={this.openEditForm}
          editButton={true}
          removeButton={true}
          colVis={false}
          exportButton={true}
          customButtons={this.customButtons}
          columnSearch={true}
          handleNullFilter={this.handleNullFilter}
          storeColumnIndex={this.storeColumnIndex}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNotification: (notification) => dispatch(addNotification(notification)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingTable);
